/**
 * Share
 */

// state

const initialState = () => ({
    items: null,
    isSending: false,
    isSuccess: false,
    isPending: false,
    isError: false,
    message: '',
    shareId: null,
    link: null,
    modal: {
        show: false,
    },
    linkmodal: {
        url: '',
        show: false,
    },
});

export const shareState = {
    share: {
        ...initialState(),
    },
};

// mutations
export const shareMutations = {
    setMediaShareModalShow(state, show) {
        state.share.modal.show = show;
    },
    setMediaShareItems(state, items) {
        state.share.items = items;
    },
    setMediaShareIsSending(state, sending) {
        state.share.isSending = sending;
    },
    setMediaShareId(state, id) {
        state.share.shareId = id;
    },
    setMediaShareLink(state, link) {
        state.share.link = link;
    },
    setMediaShareIsSuccess(state, success) {
        state.share.isSuccess = success;
    },
    setMediaShareIsPending(state, pending) {
        state.share.isPending = pending;
    },
    setMediaShareIsError(state, error) {
        state.share.isError = error;
    },
    setMediaShareMessage(state, message) {
        state.share.message = message;
    },
    // MediaShareLink Modal
    setShareLinkModalShow(state, show) {
        state.share.linkmodal.show = show;
    },
    setShareLinkModalUrl(state, url) {
        state.share.linkmodal.url = url;
    },
};

// getters
export const shareGetters = {
    getMediaShareModalShow(state) {
        return state.share.modal.show;
    },
    getMediaShareItems(state) {
        return state.share.items;
    },
    getMediaShareIsSending(state) {
        return state.share.isSending;
    },
    getMediaShareId(state) {
        return state.share.shareId;
    },
    getMediaShareLink(state) {
        return state.share.link;
    },
    getMediaShareIsSuccess(state) {
        return state.share.isSuccess;
    },
    getMediaShareIsPending(state) {
        return state.share.isPending;
    },
    getMediaShareIsError(state) {
        return state.share.isError;
    },
    getMediaShareMessage(state) {
        return state.share.message;
    },
    getShareLinkModalShow(state) {
        return state.share.linkmodal.show;
    },
    getShareLinkModalUrl(state) {
        return state.share.linkmodal.url;
    },
};

// actions
export const shareActions = {
    showMediaShareModal({ commit, state }, items) {
        commit('setMediaShareItems', items);
        commit('setMediaShareModalShow', true);
    },
    hideMediaShareModal({ dispatch }) {
        dispatch('resetMediaShare');
    },
    // share link modal
    showShareLinkModal({ commit, state }, link) {
        commit('setShareLinkModalUrl', link);
        commit('setShareLinkModalShow', true);
    },
    hideShareLinkModal({ commit, state }) {
        commit('setShareLinkModalUrl', '');
        commit('setShareLinkModalShow', false);
    },
    resetMediaShare({ state }) {
        state.share = Object.assign(
            {},
            {
                ...initialState(),
            }
        );
    },
};
